import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { PermissionGuard } from './guards/permission.guard';

// Import Containers
import { DefaultLayoutComponent } from './containers';

import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { CustomErrorComponent } from './views/error/custom-error.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    children: [
      {
        path: '',
        loadChildren: () => import('./views/auth/auth.module').then(m => m.AuthModule)
      }
    ]
  },
  // {
  //   path: 'shop',
  //   children: [
  //     {
  //       path: '',
  //       loadChildren: () => import('./views/shop/shop.module').then(m => m.ShopModule)
  //     }
  //   ]
  // },
  // {
  //   path: 'shop/:products',
  //   children: [
  //     {
  //       path: '',
  //       loadChildren: () => import('./views/shop/shop.module').then(m => m.ShopModule)
  //     }
  //   ]
  // },
  {
    path: '',
    component: DefaultLayoutComponent,
    canMatch: [AuthGuard],
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule),
        canMatch: [PermissionGuard],
        data: {
          permission: 'dashboard'
        }
      },
      {
        path: 'users',
        loadChildren: () => import('./views/users/users.module').then(m => m.UsersModule),
        canMatch: [PermissionGuard],
        data: {
          title: 'Users',
          permission: 'users'
        }
      },
      {
        path: 'profile',
        loadChildren: () => import('./views/profile/profile.module').then(m => m.ProfileModule),
        canMatch: [PermissionGuard],
        data: {
          title: 'Profile',
          permission: 'profile'
        }
      },
      {
        path: 'subscription',
        loadChildren: () => import('./views/subscription/subscription.module').then(m => m.SubscriptionModule),
        canMatch: [PermissionGuard],
        data: {
          title: 'Subscription',
          permission: 'subscription'
        }
      },
      {
        path: 'session-analysis',
        loadChildren: () => import('./views/session-analysis/session-analysis.module').then(m => m.SessionAnalysisModule),
        canMatch: [PermissionGuard],
        data: {
          title: 'Session Analysis',
          permission: 'session-analysis'
        }
      },
      {
        path: 'inventory',
        loadChildren: () => import('./views/inventory/inventory.module').then(m => m.InventoryModule),
        canMatch: [PermissionGuard],
        data: {
          title: 'Inventory',
          permission: 'inventory'
        }
      },
      {
        path: 'settings',
        loadChildren: () => import('./views/settings/settings.module').then(m => m.SettingsModule),
        canMatch: [PermissionGuard],
        data: {
          title: 'Settings',
          permission: 'settings'
        }
      },
      {
        path: 'refund-requests',
        loadChildren: () => import('./views/refund-requests/refund-requests.module').then(m => m.RefundRequestsModule),
        canMatch: [PermissionGuard],
        data: {
          title: 'Refund Requests',
          permission: 'refund-requests'
        }
      },
      {
        path: 'assign-licenses',
        loadChildren: () => import('./views/assign-licenses/assign-licenses.module').then(m => m.AssignLicensesModule),
        canMatch: [PermissionGuard],
        data: {
          title: 'Assign to Coach Pool',
          permission: 'assign-licenses'
        }
      },
      {
        path: 'license-management',
        loadChildren: () => import('./views/license-management/license-management.module').then(m => m.LicenseManagementModule),
        canMatch: [PermissionGuard],
        data: {
          title: 'License Management',
          permission: 'license-management'
        }
      },
      {
        path: 'product-code-register',
        loadChildren: () => import('./views/product-code-register/product-code-register.module').then(m => m.ProductCodeRegisterModule),
        data: {
          title: 'Product Code Register'
        }
      },
      {
        path: 'discount-coupons',
        loadChildren: () => import('./views/discount-coupons/discount-coupons.module').then(m => m.DiscountCouponsModule),
        canMatch: [PermissionGuard],
        data: {
          title: 'Discount Coupons',
          permission: 'discount-coupons'
        }
      }
    ]
  },
  {
    path: '404',
    component: P404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    component: P500Component,
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'error',
    component: CustomErrorComponent,
    data: {
      title: 'Error'
    }
  },
  { path: '**', component: P404Component }
];

// if (window.location.origin.includes('store')) {
//   routes.splice(0);
//   routes.push({
//     path: '',
//     children: [
//       {
//         path: '',
//         loadChildren: () => import('./views/shop/shop.module').then(m => m.ShopModule)
//       }
//     ]
//   },
//   { path: '**', component: P404Component }
//   );
// }

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
